import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { Subscription } from 'rxjs';
import { Location } from '@angular/common';
import { User } from '../../auth/user.model';
import { StorageService } from '../../storage/storage.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Output() sideNavToggle = new EventEmitter<void>();
  isAuth = false;
  showHamburgerButton = true;
  showBackButton = false;
  authSubscription: Subscription;
  user: User;
  currentProject: number;

  constructor(
    private authService: AuthService,
    private location: Location,
    private storageService: StorageService
  ) { }

  ngOnInit() {
    this.currentProject = this.storageService.getPreferredProject();
    this.authSubscription =  this.authService.authChange.subscribe(authStatus => {
      this.isAuth = authStatus;
    });
    this.user = this.authService.getUser();
  }

  toggleMenuAndBackbutton() {

  }

  getCurrentProjectNameById(id) {
    for (const index in this.user.accesses) {
      const project = this.user.accesses[index]['project'];
      if (project['id'] === id){
        return project['first_name'];
      }
    }
    return id;
  }

  setPreferredProject(projectId){
    this.storageService.setPreferredProject(projectId);
    this.currentProject = this.storageService.getPreferredProject();
  }

  onToggleSideNav() {
    this.sideNavToggle.emit();
  }

  onLogout() {
    this.authService.logout();
  }

  goBack() {
    this.location.back();
  }

  ngOnDestroy() {
    this.authSubscription.unsubscribe();
  }
}
